import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import Unauthorized from "./Unauthorized";
import PendingApprovalOverlay from "./PendingApprovalOverlay";

const ProtectedRoute = ({ children, requiredRole }) => {
  const { user, isAuthenticated } = useAuth();

  if (!isAuthenticated) {
    // Not logged in, redirect to login
    return <Navigate to="/sign-in" replace />;
  }

  // Check for required role if specified
  if (requiredRole && user.role !== requiredRole) {
    // User doesn't have the required role, show unauthorized message
    return (
      <Unauthorized message="You don't have permission to access this page. This feature requires higher privileges." />
    );
  }

  // Show the overlay for users with "new" status, but allow them to navigate
  if (user.status === "new") {
    return (
      <>
        {children}
        <PendingApprovalOverlay />
      </>
    );
  }

  // Logged in, not new status, and has the required role (if any), show requested component
  return children;
};

export default ProtectedRoute;
